import { axios, Response } from '../index'

export type Profile = {
  id: string
}

export type CreateClientDTO = {
  firstName: string
  lastName: string
  cpf: string
  responsibleId?: string
  email?: string
  gender: string
  birthday: string
  responsibleCpf?: string
}

export default async function createClient(
  data: CreateClientDTO
): Response<Profile> {
  return await axios.post('/v1/patients', data)
}
